var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('TextBlock',{attrs:{"title":_vm.content.title,"content":_vm.content.text}}),_vm._v(" "),_c('div',{class:_vm.$style.content},[_c('p',{attrs:{"data-anim":"stagger"},domProps:{"innerHTML":_vm._s(_vm.content.paragraph)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e38acda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ParagraphBlock.vue
// module id = null
// module chunks = 